/***************************************************************
5/27/2017
Alexander Self
Timesheet edit modal
- Summary of edited timesheet to be submitted; used as a check prior to
  submitting timesheets
***************************************************************/
import React from 'react';
const $ = window.$;


const TimesheetDeleteModal = ({ id, timesheet, employee, deleteTimesheet }) => {
  $(document).ready(() => {
    $(`#${id}`).modal();
  });

  return (
    <div id={id} className="modal modal-fixed-footer">
      <div className="modal-content">
        <h4>Delete Timesheet</h4> <hr />
        <b>Please note that the timesheet will be deleted permanently.</b>
        <blockquote className="alert-red">
          <div className="row delete-summary">
            <ul className="collection">
              <li className="collection-item flow-text">Employee ID: <b><span className="right">{employee.eid}</span></b></li>
              <li className="collection-item flow-text">Name: <b><span className="right">{employee.firstName} {employee.lastName}</span></b></li>
              <li className="collection-item flow-text">Date: <b><span className="right">{ timesheet.date ? timesheet.date.split('T')[0] : '' }</span></b></li>
              <li className="collection-item flow-text">Location: <b><span className="right">{ timesheet.location }</span></b></li>
              <li className="collection-item flow-text">Gang: <b><span className="right">{timesheet.gang}</span></b></li>
              <li className="collection-item flow-text">Start Time: <b><span className="right">{ timesheet.startTime }</span></b></li>
              <li className="collection-item flow-text">End Time: <b><span className="right">{ timesheet.endTime }</span></b></li>
              <li className="collection-item flow-text">Grade: <b><span className="right">{timesheet.grade}</span></b></li>
              <li className="collection-item flow-text">Shift: <b><span className="right">{timesheet.shift}</span></b></li>
              <li className="collection-item flow-text">Regular Hours: <b><span className="right">{timesheet.regHours}</span></b></li>
              <li className="collection-item flow-text">Overtime: <b><span className="right">{timesheet.otHours}</span></b></li>
              <li className="collection-item flow-text">Total Hours: <b><span className="right">{timesheet.summaryOfHours}</span></b></li>
            </ul>
          </div>
        </blockquote>
      </div>
      <div className="modal-footer">
        <button type="button" className="modal-action modal-close waves-effect btn-flat">Cancel</button>
        <button type="button" onClick={() => deleteTimesheet({ timesheet, employee })}
          className="modal-action modal-close waves-effect btn-flat">
          Delete
        </button>
      </div>
    </div>
  );
};

export default TimesheetDeleteModal;



// WEBPACK FOOTER //
// ./src/components/timesheets/delete/timesheet_delete_modal.js